import React from 'react'
import styled from 'styled-components'
import { Tablet, MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import { OutlinedButton, ButtonPaint, ButtonSize, Link } from 'streamr-ui'
import RoundedBox from '../RoundedBox'
import governance from './assets/governance.png'
import governance2x from './assets/governance@2x.png'
import Topic from '~shared/Topic'

const IconContainer = styled.div`
    position: relative;
    width: 240px;
    height: 240px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-70%, -40%);
        width: 100%;
    }

    @media ${MqTablet} {
        width: 276px;
        height: 276px;

        img {
            transform: translate(-50%, -50%);
        }
    }

    @media ${MqDesktop} {
        width: 408px;
        height: 408px;
    }
`

const UnstyledGovernance = (props) => (
    <RoundedBox {...props} $appear>
        <RoundedBox.Inner>
            <RoundedBox.Content>
                <Topic.Title>Governance</Topic.Title>
                <Topic.Paragraph>
                    Streamr is using a lightweight governance system of community voting on Streamr
                    Improvement Proposals (SIPs) via the Snapshot app. All token holders are
                    eligible to vote and you can browse current and past proposals.
                </Topic.Paragraph>
                <OutlinedButton
                    tag={Link}
                    size={ButtonSize.Moose}
                    paint={ButtonPaint.PrimaryOutlined}
                    href="https://snapshot.org/#/streamr.eth"
                    blank
                >
                    Streamr on Snapshot
                </OutlinedButton>
            </RoundedBox.Content>
            <RoundedBox.Icon>
                <IconContainer>
                    <img src={governance} srcSet={governance2x} alt="" />
                </IconContainer>
            </RoundedBox.Icon>
        </RoundedBox.Inner>
    </RoundedBox>
)

const Governance = styled(UnstyledGovernance)`
    @media (max-width: ${Tablet - 1}px) {
        ${Topic.Title} {
            margin-top: 1.25rem;
        }
    }
`

export default Governance
